<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-grundpfandrechte">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Grundpfandrechte" | translate }}</h2>
  </ng-container>

  <cap-grundpfandrecht-table
    [hasRight]="grundstueckEntry?.permissions?.grundpfandrecht && ersterfassungUebergeben"
    [listLoader]="listLoader">
  </cap-grundpfandrecht-table>
</cap-rubrik>
